import { formatGithubAuthorization, resolveGithubToken } from './resolveGithubToken'

export function buildGithubHeaders(accept: string): HeadersInit {
  const headers: HeadersInit = { Accept: accept }
  const authorization = formatGithubAuthorization(resolveGithubToken())
  if (authorization) {
    headers.Authorization = authorization
  }
  return headers
}
